(function (win) {
    "use strict";
    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;
    function ready(selector, fn) {
    // Store the selector and callback to be monitored
    listeners.push({
        selector: selector,
        fn: fn,
    });
    if (!observer) {
        // Watch for changes in the document
        observer = new MutationObserver(check);
        observer.observe(doc.documentElement, {
        childList: true,
        subtree: true,
        });
    }
    // Check if the element is currently in the DOM
    check();
    }
    function check() {
    // Check the DOM for elements matching a stored selector
    for (
        var i = 0, len = listeners.length, listener, elements;
        i < len;
        i++
    ) {
        listener = listeners[i];
        // Query for elements matching the specified selector
        elements = doc.querySelectorAll(listener.selector);

        for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
        element = elements[j];
        // Make sure the callback isn't invoked with the
        // same element more than once
        if (!element.ready) {
            element.ready = "select";
            // Invoke the callback with the element
            listener.fn.call(element, element);
        }
        }
    }
    }
    win.eleReady = ready;
})(this);



/* Main Initialization Function */
function initEnhancements() {

    // Current page url
    const currentUrl = window.location.origin + window.location.pathname;
    
    // Prepend toolbar to collection container
    const toolbar = document.querySelector('.page-title-wrapper-lookbook');
    const collection = document.querySelector('.collection');
    if (toolbar && collection && !collection.contains(toolbar)) {
        collection.insertBefore(toolbar, collection.firstChild);
    }

    // Add class on page title wrapper
    const pageTitle = document.querySelector('.articleLookbook-title');
    if (pageTitle) {
        const pageTitleWrapper = pageTitle.closest('.articleLookbook-block');
        pageTitleWrapper?.classList.add('page-title-wrapper-lookbook');
    }

}


/* Popup HTML for Quick View */
// const popupHTML = `
//     <div class="CP-quick-view-modal" style="display:none;">
//         <div class="CP-modal-content">
//         <span class="CP-close-btn">&times;</span>
//         <div class="CP-product-media"></div>
//         <div class="CP-product-title"></div>
//         <div class="CP-product-price"></div>
//         <div class="CP-product-info"></div>
//         <div class="CP-view-details"><button class="CP-view-details-btn">View Details</button><div>
//         </div>
//     </div>
//     `;
// document.body.insertAdjacentHTML("beforeend", popupHTML);



/******************************************
        * Main Code Execution *
******************************************/
window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (timeOutFn) {
  return setTimeout(timeOutFn, 1000 / 60);
};
window['CP_FESTIVE_THEME'] = function () {
  if (document.querySelector('body.template-page') && !document.body.classList.contains('CP_FESTIVE_THEME')) {
        document.body.classList.add('CP_FESTIVE_THEME');
    
   
    // Call function to initialize enhancements
    initEnhancements();



    const productGrid = document.querySelector(".navratri-collection") || document.body;
   

    // Delegated click handler for size filter toggle
    document.addEventListener('click', function (e) {
        const openBtn = e.target.closest('.filter-size');
        const closeBtn = e.target.closest('.sizesfilter-dropdown-menu .icon-wrapper');
        const filterItem = e.target.closest('.sizesfilter-dropdown-menu ul.facets-layout li.list-menu__item');

        if (openBtn) {
            document.body.classList.add('size-toolbar-modal-open');
            document.querySelector('.sizesfilter-dropdown-menu')?.classList.add('show-dropdownmenu');
          //
            document.body.classList.remove('availability-toolbar-modal-open');
            document.querySelector('.availabilityfilter-dropdown-menu').classList.remove('show-dropdownmenu');
          //
            document.documentElement.classList.remove('quick_shop_popup_mobile');
            document.querySelector('.quick_shop_option_2 #halo-card-mobile-popup.show').remove('show');
        }
        if (closeBtn) {
            document.body.classList.remove('size-toolbar-modal-open');
            document.querySelector('.sizesfilter-dropdown-menu')?.classList.remove('show-dropdownmenu');
        }
        if (filterItem) {
            document.body.classList.remove('size-toolbar-modal-open');
            document.querySelector('.sizesfilter-dropdown-menu')?.classList.remove('show-dropdownmenu');
        }
    });
    // Delegated click handler for availability filter toggle
    document.addEventListener('click', function (e) {
        const openBtn = e.target.closest('.filter-availability');
        const closeBtn = e.target.closest('.availabilityfilter-dropdown-menu .icon-wrapper');
        //const filterItem = e.target.closest('.availabilityfilter-dropdown-menu ul.facets-layout li.list-menu__item');

        if (openBtn) {
            document.body.classList.add('availability-toolbar-modal-open');
            document.querySelector('.availabilityfilter-dropdown-menu')?.classList.add('show-dropdownmenu');
          //
            document.documentElement.classList.remove('quick_shop_popup_mobile');
            document.querySelector('.quick_shop_option_2 #halo-card-mobile-popup.show').remove('show');
          //
            document.body.classList.remove('size-toolbar-modal-open');
            document.querySelector('.sizesfilter-dropdown-menu').classList.remove('show-dropdownmenu');
        }
        if (closeBtn) {
            document.body.classList.remove('availability-toolbar-modal-open');
            document.querySelector('.availabilityfilter-dropdown-menu')?.classList.remove('show-dropdownmenu');
        }
    });


    

    /* Add multiple images */
    const collectionProductsUrl = window.location.origin + window.location.pathname + '/products.json'; // Collection page url products.json
    
    async function fetchProductData() {
      const response = await fetch(`${collectionProductsUrl}?limit=2000`);
      const data = await response.json();
      console.log('Fetched product data:', response);
      return data?.products || [];
    }


    /* Quick View */
    async function fetchProductHTML(slug) {
      const url = `https://mysanskritam.com/products/${slug}`;

      try {
        const res = await fetch(url, {
          method: "GET",
        });

        if (!res.ok) {
          window.location.href = `/products/${slug}`;
          return;
        }

        const html = await res.text();
        return html;
      } catch (error) {
        console.error("Error fetching HTML content:", error);
        return null;
      }
    }

    let currentSlug = null;
    document.addEventListener("click", async (e) => {
      if ( e.target.classList.contains("CP-quick-view-btn") ) {
            const modal = document.querySelector(".CP-quick-view-modal");
            modal.style.display = "block";
            modal.classList.add("cp_modal_loading");
            let productItem;
            if (e.target.closest(".product")) {
                productItem = e.target.closest(".product");
            }
            else {
                productItem = e.target.closest(".st-product-wrap");
            }

            const anchor = productItem.querySelector('a[href*="/products/"]');
            if (!anchor) return;

            const href = anchor.getAttribute("href");
            const slugMatch = href.match(/\/products\/([^/?#]+)/);
            const slug = slugMatch ? slugMatch[1] : null;

            if (!slug) return;
            currentSlug = slug;
            const productHTML = await fetchProductHTML(slug);
            const parser = new DOMParser();
            const productDoc = parser.parseFromString(productHTML, "text/html");

            const modalContent = modal.querySelector(".CP-modal-content");
            const closeBtn = modal.querySelector(".CP-close-btn");
            const mediaContainer = modalContent.querySelector(".CP-product-media");
            const detailContainer = modalContent.querySelector(".CP-product-info");
            const titleContainer = modalContent.querySelector(".CP-product-title");
            const priceContainer = modalContent.querySelector(".CP-product-price");

            mediaContainer.innerHTML = "";
            detailContainer.innerHTML = "";
            titleContainer.innerHTML = "";
            priceContainer.innerHTML = "";

            modal.style.display = "block";

            closeBtn.addEventListener("click", () => {
                modal.style.display = "none";
            });

            const productMedia = productDoc.querySelector(".productView-image-wrapper").cloneNode(true);

            const productDescTab = productDoc.querySelector(".productView-tab .tab-content#tab-description .toggle-content") || productDoc.querySelector(".custom-accordion-wrapper .accordion-item:first-child .accordion-content");
            const productDetails = productDescTab.cloneNode(true);

            const productTitle = productDoc.querySelector(".productView-title")?.cloneNode(true);

            const productPrice = productDoc.querySelector(".price-item.price-item--regular").cloneNode(true);

            mediaContainer.appendChild(productMedia);

            const swiperSlides = mediaContainer.querySelectorAll(".slick-slide");

            swiperSlides.forEach((slide) => {
                const img = slide.querySelector("img");
                if (img) {
                    const dataSrc = img.getAttribute("data-src");
                    if (dataSrc && !img.getAttribute("src")) {
                        img.setAttribute("src", dataSrc);
                        img.setAttribute("width", 767);
                        img.setAttribute("height", 500);
                    }
                }
            });

            setTimeout(() => {
                $('.CP-product-media .productView-nav').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    dots: true,
                    infinite: true,
                    arrows: false, // No arrows
                });
            }, 100);

            titleContainer.appendChild(productTitle);
            priceContainer.appendChild(productPrice);

            detailContainer.appendChild(productDetails);
            modal.classList.remove("cp_modal_loading");
        }

      /**/
      if (e.target.classList.contains("CP-atc-btn")) {
        const productItem = e.target.closest(".product-item");
    
        if (productItem) {
          // Trigger the real ATC or quickshop button
          const realAtcButton = productItem.querySelector('[data-quickshop-popup], [data-btn-addtocart]');
          if (realAtcButton) {
            realAtcButton.click();
          }
          // Add popup class to card if it exists
          const card = productItem.querySelector(".card");
          if (card) {
            card.classList.add("quickshop-popup-show");
          }
          // ✅ Add class to <html> tag on mobile
          if (window.innerWidth <= 767) {
            document.documentElement.classList.add('quick_shop_popup_mobile');
          }
          console.log("ATC clicked: class added to <html>");
        }
      }
      /**/
      // ✅ Handle popup close (using .closest for robust event targeting)
      if (  e.target.closest('.background-overlay, #halo-card-mobile-popup .mobile-popup-header .close-modal, #halo-cart-sidebar .halo-sidebar-close')  ) {
        document.documentElement.classList.remove('quick_shop_popup_mobile');
      }

      
  
      if (e.target.classList.contains("CP-view-details-btn")) {
        window.location.href = `/products/${currentSlug}`;
      }
    });







// slider container
function initSlickSliders() {
    $('.product-itemimg-slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        infinite: true,
        arrows: false
    });
}
$(document).ready(function() {
    initSlickSliders();
});



/*
// Show-More infinite scroll functionality
(function () {
  
  function initAutoInfiniteScroll() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const btn = entry.target;
          if (!btn.classList.contains('is-loading')) {
            btn.click(); // triggers existing infinite scroll logic
            setTimeout(initSlickSliders, 500);
          }
        }
      });
    }, { threshold: 0.2 });

    // Watch for new infinite scroll buttons
    const mutationObserver = new MutationObserver(() => {
      document.querySelectorAll('.pagination-page-infinite .button[data-infinite-scrolling]').forEach((btn) => {
        if (!btn.dataset.observed) {
          observer.observe(btn);
          btn.dataset.observed = "true"; // mark as observed
        }
      });
    });

    // Start observing DOM changes
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    // Run once on page load too
    document.querySelectorAll('.pagination-page-infinite .button[data-infinite-scrolling]').forEach((btn) => {
      if (!btn.dataset.observed) {
        observer.observe(btn);
        btn.dataset.observed = "true";
      }
    });

  }

  document.addEventListener('DOMContentLoaded', initAutoInfiniteScroll);
})();
*/






  } else if (!document.body.classList.contains('CP_FESTIVE_THEME')) {
    window.requestAnimationFrame(window.CP_FESTIVE_THEME);
  }
};

window.CP_FESTIVE_THEME();
